import React from 'react';

const themes = [
  { id: 'light', label: '🌤' },
  { id: 'dark', label: '🌑' },
  { id: 'warm', label: '🔥' },
  { id: 'cool', label: '❄️' },
];

const ThemeSwitcher = ({ selectedTheme, onChange }) => {
  return (
    <div className="flex gap-1 bg-input rounded-md px-2 py-1">
      {themes.map(({ id, label }) => (
        <label
          key={id}
          className={`cursor-pointer px-2 py-1 rounded-md transition-colors ${
            selectedTheme === id ? 'bg-accent text-white' : 'text-text hover:bg-hover'
          }`}
        >
          <input
            type="radio"
            name="theme"
            value={id}
            checked={selectedTheme === id}
            onChange={() => onChange(id)}
            className="hidden"
          />
          {label}
        </label>
      ))}
    </div>
  );
};

export default ThemeSwitcher;
